import "./notePaper.scss";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { AddNotePaper, DeleteNotePaper, GetNotePapers } from "../../services/notePaperService";
import IconButton from "../iconButton/iconButton";
import StickyNote from "../stickyNote/stickyNote";
import Tooltip from "../tooltip/tooltip";
import EnterIcon from "../../assets/images/enter.svg";

export default function NotePaper() {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [deletLoading, setDeletLoading] = useState(null);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
      getNotePapers();
    }, []);
  
  const getNotePapers = async () => {
    try {
      const response = await GetNotePapers();
      setNotes(response.notepapers);
    } catch (err) {
      toast.error(err.error, { toastId: "error" });
    }
  }

  const  handleAddNotePaper = (e) => {
    setNote(e.target.value);
  }
  const handleEnter = (e) => {
    if(e.key === "Enter") {
     addNotePaper();
    }
  }
  const addNotePaper =  async () => {
    if (note !== "") {
      try {
        setLoading(true);
        await AddNotePaper(note);
        setLoading(false);
        setNote("");
        getNotePapers();
      } catch (err) {
        setLoading(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  }
  const deleteNotePaper = async (notePaperId) => {
    try {
      setDeletLoading(notePaperId);
      await DeleteNotePaper(notePaperId);
      setDeletLoading(null);
      getNotePapers();
    } catch (err) {
      setDeletLoading(null);
      toast.error(err.error, { toastId: "error" });
    }
  }

  return (
    <div className="notePaper">
      <div className="ribon flex align-center justify-center">
        <Tooltip tip="یادداشت هایی که موقتی هستن رو ثبت کن وقتی نخواستیشون برای همیشه پاکشون کن"  />
        چرک نویس
      </div>
      <div className="content">
        <div className="addNoteWrapper">
          <input
            className= "addNoteInput"
            type="text"
            onChange={(e) => handleAddNotePaper(e)}
            onKeyDown = {e=>handleEnter(e)}
            placeholder="اینجا بنویس"
            value={note}
          />
          <IconButton icon={EnterIcon} onClick={addNotePaper} loading={loading} tooltip={"ثبت"} />
        </div>
        <div className="notes">
          {notes.length > 0 && 
          notes.map( (note) => {
            return (
              <StickyNote  key={note.ID} note={note.note} onClick={() => deleteNotePaper(note.ID)} loading={deletLoading === note.ID} />
            )
          })
        }
        </div>
      </div>
    </div>
  );
}
